import { render, staticRenderFns } from "./AccomItem.vue?vue&type=template&id=03a11ba0&scoped=true&"
import script from "./AccomItem.vue?vue&type=script&lang=js&"
export * from "./AccomItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03a11ba0",
  null
  
)

export default component.exports